import React from 'react';
import { XCircleIcon } from '@heroicons/react/outline';

function ErrorMessage({ message, type }) {
    let icon = null;
    let colorClass = null;
    switch (type) {
        case 'error':
            icon = <XCircleIcon className="w-6 h-6 text-red-600" />;
            colorClass = 'bg-red-100 border-red-600';
            break;
        case 'success':
            icon = <XCircleIcon className="w-6 h-6 text-green-600" />;
            colorClass = 'bg-green-100 border-green-600';
            break;
        case 'warning':
            icon = <XCircleIcon className="w-6 h-6 text-yellow-600" />;
            colorClass = 'bg-yellow-100 border-yellow-600';
            break;
        default:
            icon = <XCircleIcon className="w-6 h-6 text-red-600" />;
            colorClass = 'bg-red-100 border-red-600';
            break;
    }
    return (
        <div className="flex justify-center mt-20 px-5">
            <div
                className={` flex items-center p-4 ${colorClass} rounded-md border shadow space-x-2`}>
                <div>{icon}</div>
                <div>{message}</div>
            </div>
        </div>
    );
}

export default ErrorMessage;
